module.exports = __webpack_public_path__ + "img/marketSend.a0396a9a.svg";